import { date, object, string } from "yup";

export const registerAgentSchema = object({
  agent_name: string().required("Please enter Agent name"),
  start_date: date().required("Please enter Starting date"),
  expiration_date: date().required("Please enter Expiration date"),
  street_address: string().required("Please enter Address"),
  city: string().required("Please enter City name"),
  state: string().required("Please select State"),
  zipcode: string().required("Please enter Zip Code"),
  country: string().required("Please select an address"),
  phone_number: string().test({
    name: "phone_number",
    message: "Please enter valid mobile number",
    test: (value: any) => !value || value.length > 10,
  }),
});
